<div class="pizza-builder">
  <div class="pizza-progress">
    Monte sua pizza
    @if (pizza.size) {
      <span> · {{pizza.size}}</span>
    }
    @if (pizza.total > 0) {
      <span class="running">{{pizza.total | currency:'BRL'}}</span>
    }
  </div>

  @if(!pizza.mode) {
    <div>
      <div class="pizza-step">É para comer aqui ou para levar?</div>
      <div class="choice-grid">
        <button type="button" class="choice-card" (click)="chooseMode('onsite')">Comer aqui</button>
        <button type="button" class="choice-card" (click)="chooseMode('delivery')">Levar</button>
      </div>
    </div>
  }
  @else if(pizza.size == '') {
    <div>
      <div class="pizza-step">Escolha o tamanho</div>
      <div class="choice-grid">
        @for (size of pConfig.sizes; track size.name) {
          <button type="button" class="choice-card" (click)="chooseSize(size.name)">
            <div class="choice-title">{{size.name}}</div>
            <div class="choice-meta">{{size.slices}} pedaços · até {{size.max_flavors}} sabores</div>
          </button>
        }
      </div>
      <button class="btn btn-lg btn-secondary" (click)="stepBack()">Voltar</button>
    </div>
  }
  @else if(!flavorsDone) {
    <div>
      <div class="pizza-step">Escolha o{{maxFlavors > 1 ? 's' : ''}} sabor{{maxFlavors > 1 ? 'es' : ''}}</div>
      @if(pizza.flavors.length > 0) {
        <div class="pizza-choice">
          <b>Escolhidos ({{pizza.flavors.length}}/{{maxFlavors}}):</b>
          @for (flavor of pizza.flavors; track flavor) {
            <div>{{flavor}}</div>
          }
        </div>
        <button class="btn btn-lg btn-primary" (click)="finishFlavors()">Continuar</button>
      }
      <div ngbAccordion [closeOthers]="true">
        @for (pcat of categories; track pcat) {
          <div ngbAccordionItem [class.hidden]="pcat.mixBlocked">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="accordion-button">{{pcat.name}}</button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  @for (product of pcat.products; track product) {
                    <div class="products" [class.picked]="pizza.flavors.indexOf(product.name) >= 0" (click)="chooseFlavor(pcat.name, product)">
                      <div class="product-name">{{product.name.split("Pizza de ")[1] || product.name.split("Pizza ")[1] || product.name}}</div>
                      <div class="product-price">{{product.prettyPrice | currency:'BRL'}}</div>
                      <div><small>{{product.description ? "(" + product.description + ")" : ""}}</small></div>
                    </div>
                  }
                </ng-template>
              </div>
            </div>
          </div>
        }
      </div>
      <hr/>
      <button class="btn btn-lg btn-secondary" (click)="stepBack()">Voltar</button>
    </div>
  }
  @else if(!crustsDone) {
    <div>
      <div class="pizza-step">Escolha a borda</div>
      <div class="choice-grid">
        @for (crust of pConfig.crusts; track crust.name) {
          <button type="button" class="choice-card" [class.picked]="chosenCrusts[crust.name]" (click)="chooseCrust(crust.name)">
            <div class="choice-title">{{crust.name}}</div>
            <div class="choice-meta">+{{crust.sizePrice | currency:'BRL'}}</div>
          </button>
        }
      </div>
      <button class="btn btn-lg btn-primary" (click)="finishCrusts()">{{pizza.crusts.length ? 'Continuar' : 'Sem borda'}}</button>
      <button class="btn btn-lg btn-secondary" (click)="stepBack()">Voltar</button>
    </div>
  }
  @else if(!ingredientsDone) {
    <div>
      <div class="pizza-step">Quer adicionar ingredientes?</div>
      <div class="choice-grid">
        @for (ingredient of pConfig.ingredients; track ingredient.name) {
          <button type="button" class="choice-card" [class.picked]="chosenIngredients[ingredient.name]" (click)="chooseIngredient(ingredient.name)">
            <div class="choice-title">{{ingredient.name}}</div>
            <div class="choice-meta">+{{ingredient.sizePrice | currency:'BRL'}}</div>
          </button>
        }
      </div>
      <button class="btn btn-lg btn-primary" (click)="finishIngredients()">Continuar</button>
      <button class="btn btn-lg btn-secondary" (click)="stepBack()">Voltar</button>
    </div>
  }
  @if(ingredientsDone && !noteDone) {
    <div>
      <div class="pizza-step">Observações</div>
      <textarea class="form-control" rows="4" [(ngModel)]="pizza.note" placeholder="Ex: bem assada, sem cebola"></textarea>
      <br/>
      <button class="btn btn-lg btn-primary" (click)="finishNote()">Revisar</button>
      <button class="btn btn-lg btn-secondary" (click)="stepBack()">Voltar</button>
    </div>
  }

  @if(noteDone) {
    <div class="review-pizza">
      <h3>Revisar pizza</h3>
      <div class="rv-container">
        <h4>{{pizza.size}} · {{pizza.mode == 'delivery' ? 'Viagem' : 'Salão'}}</h4>
        <div>{{pizza.flavors.join(' | ')}}</div>
        @if(pizza.crusts.length > 0) {
          <div>Bordas: {{pizza.crusts.join(', ')}}</div>
        }
        @if(pizza.ingredients.length > 0) {
          <div>Adicionais: {{pizza.ingredients.join(', ')}}</div>
        }
        @if(pizza.note) {
          <pre>{{pizza.note}}</pre>
        }
        <div class="total"><b>{{pizza.total | currency:'BRL'}}</b></div>
      </div>
      <button class="btn btn-lg btn-success" (click)="confirmPizza()">Adicionar</button>
      <button class="btn btn-lg btn-secondary" (click)="stepBack()">Voltar</button>
    </div>
  }
</div>
